const getSupabaseConfig = () => {
  const url = process.env.REACT_APP_SUPABASE_URL;
  const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error('Supabase is not configured. Check your environment variables.');
  }
  return { url, anonKey };
};

/**
 * Validate a shared-transfer pickup/dropoff point within a hub city service area.
 * @param {{ hubCity: string, point: object }} params
 * @param {string} [authToken]
 */
export async function validateSharedTransferLocation(params, authToken) {
  const { url, anonKey } = getSupabaseConfig();
  const token = authToken || anonKey;

  const response = await fetch(`${url}/functions/v1/shared-transfer-validate-location`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: anonKey,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      hubCity: params.hubCity,
      point: params.point,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.valid === false) {
    throw new Error(data.error || 'Address is outside the selected city service area.');
  }

  return data;
}
